import { render } from "./ABanner.vue?vue&type=template&id=67e0ff96"
import script from "./ABanner.vue?vue&type=script&lang=js"
export * from "./ABanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__